<div class="c-filter-box">
	<div class="c-filter-box__title">
		<p class="u-text--medium">
			{{ config.title | translate }}

			@if (config.name === 'meals') {
				<button (click)="showInfo.set(true)" class="c-btn-link u-text--normal u-text--sm">Uitleg</button>
			}

			@if (config.name === 'paymentMethod') {
				<tvcore-tooltip>
					<strong>Uitzondering bij directe betaling:</strong><br />
					Meerderjarige personen in schuldbemiddeling, onder bewindvoering of zonder bankrekening kunnen via een sociale partnerorganisatie of een Rap op Stapkantoor een
					reservatiebewijs verkrijgen en aan de kassa betalen.
				</tvcore-tooltip>
			}
		</p>
	</div>

	@if (form) {
		<form [formGroup]="form">
			@for (option of config.options; track option) {
				<tvcore-checkbox [name]="option">
					{{ config.base + '.' + option | translate }}
				</tvcore-checkbox>
			}
		</form>
	}
</div>

@if (config.name === 'meals') {
	<tvcore-dialog (close)="showInfo.set(false)" [title]="'HOME.MEALS_DIALOG.TITLE' | translate" [visible]="showInfo()">
		<div [innerHTML]="'HOME.MEALS_DIALOG.CONTENT' | translate"></div>
	</tvcore-dialog>
}
